import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  borrower_principal: Yup.string().required("Required"),
  authorized_agent: Yup.string().required("Required"),
  other_authorized_agent_name: Yup.string().when("authorized_agent", {
    is: "other",
    then: Yup.string().required("Required"),
    otherwise: Yup.string().nullable(),
  }),
});

export const initialValues = (appId: number) => ({
  id: "",
  loan_application_id: appId,
  created_at: "",
  borrower_principal: "",
  authorized_agent: "",
  other_authorized_agent_name: "",
});
